<template>

  <div class="dashboard reviews">

    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Дашборд: {{ project.name }}</h4>
            <div class="sub-title">Площадок {{ project.resources }}</div>
          </div>
        </div>

 <TopBlock></TopBlock>

      </div>
    </div>

    <div class="row">
      <div class="col">
        <ResourceStat></ResourceStat>
      </div>
      <div class="col">
        <ToneStat></ToneStat>
        <AnswerStat></AnswerStat>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <RatingGraph :show_date="true" active_interval_name="week" :max_show="2"></RatingGraph>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ToneGraph></ToneGraph>
      </div>
    </div>


  </div>
</template>

<script>


import ResourceStat from "@/views/dictionary/review/components/ResourceStat.vue";
import ToneStat from "@/views/dictionary/review/components/ToneStat.vue";
import AnswerStat from "@/views/dictionary/review/components/AnswerStat.vue";
import RatingGraph from "@/views/dictionary/review/components/RatingGraph.vue";
import ToneGraph from "@/views/dictionary/review/components/ToneGraph.vue";
import moment from "moment/moment";
import Header from "@/components/Header.vue";
import TopBlock from "@/components/TopBlock.vue";
import {LinksApi} from "@/api/links";

export default {
  name: 'FrontPage',
  components: {
    TopBlock,
    Header,
    ToneGraph,
    RatingGraph,
    AnswerStat,
    ToneStat,
    ResourceStat,
  },

  data() {
    return {
      // report_request: false,

    }
  },
  computed: {
    projectId: {
      get: function () {
        return this.$store.getters.currentProjectId;
      },
      set: function () {
      }
    },
    project: {
      get: function () {
        return this.$store.getters.currentProject;
      },
    }
  },
  mounted: function () {

  },

  methods: {

  }
}

</script>

<style scoped>
.report {
  position: relative;
  z-index: 0;
  &.loader {
    height: 38px;
        &:before {
          content: "";
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(1px);
          width: 100%;
          display: block;
          position: absolute;
          top: 0;
          height: 38px;
          left: 0;
          z-index: 1;
        }

        &:after {
          animation: changeContent .8s linear infinite;
          display: block;
          content: "⠋";
          font-size: 30px;
          color: var(--deep-blue);
          z-index: 2;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

      }
  a {
    font-size: 18px;
    font-weight: bold;
  }
}

@keyframes changeContent {
  10% {
    content: "⠙";
  }
  20% {
    content: "⠹";
  }
  30% {
    content: "⠸";
  }
  40% {
    content: "⠼";
  }
  50% {
    content: "⠴";
  }
  60% {
    content: "⠦";
  }
  70% {
    content: "⠧";
  }
  80% {
    content: "⠇";
  }
  90% {
    content: "⠏";
  }
}

</style>
